import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {listenerMiddleware} from '../state/listenerMiddleware';
import {ConfigState} from './ConfigState.interface';
import {
  CONFIG_STATE_NAME,
  LOCAL_STORAGE_IPX_MEDIA_NETWORK_USING_AGREED_KEY,
  SESSION_STORAGE_IPX_MEDIA_MUTED_KEY,
} from './constants';

export const configSlice = createSlice({
  name: CONFIG_STATE_NAME,
  initialState: {
    isIpxMediaMuted: true,
    isIpxMediaNetworkUsingAgreed: false,
  } as ConfigState,
  reducers: {
    setIsIpxMediaMuted: (state, action: PayloadAction<boolean>) => {
      state.isIpxMediaMuted = action.payload;
    },
    setIsIpxMediaNetworkUsingAgreed: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isIpxMediaNetworkUsingAgreed = action.payload;
    },
  },
});

export const {setIsIpxMediaMuted, setIsIpxMediaNetworkUsingAgreed} =
  configSlice.actions;

listenerMiddleware.startListening({
  actionCreator: setIsIpxMediaMuted,
  effect: action => {
    sessionStorage.setItem(
      SESSION_STORAGE_IPX_MEDIA_MUTED_KEY,
      action.payload ? 'true' : 'false'
    );
  },
});

listenerMiddleware.startListening({
  actionCreator: setIsIpxMediaNetworkUsingAgreed,
  effect: action => {
    localStorage.setItem(
      LOCAL_STORAGE_IPX_MEDIA_NETWORK_USING_AGREED_KEY,
      action.payload ? 'true' : 'false'
    );
  },
});
